import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { ELIMSSample } from "../domain/ELIMS/ELIMS-sample";
import { SampleFilters } from "../model/sample-filters.model";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { ELIMSSampleDTO } from "./dto/ELIMS/elims-sample.dto";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class SampleService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/sample`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBare);
    }

    getSampleByFilters(filters: SampleFilters) {
        this.loadingTask.activateLoading();

        let params = new HttpParams();

        params = params.append('dateDebut', filters.DateDebut.toISOString());
        params = params.append('dateFin', filters.DateFin.toISOString());
        params = params.append('referenceEOL', filters.ReferenceEOL);
        params = params.append('codeDossier', filters.CodeDossier);
        params = params.append('projet', filters.Projet);
        params = params.append('referenceClient', filters.ReferenceClient);
        params = params.append('mainContactName', filters.MainContactName);

        return this.http.get(`${this.serviceUrl}/byFilter`, this.generateHeaderWithParameters(params)).pipe(
            catchError(this.handleError<any>('getSampleByFilters')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: ELIMSSampleDTO[]) => {
                return response.map((item: ELIMSSampleDTO) => {
                    return mapper.map(item, ELIMSSampleDTO, ELIMSSample);
                });
            }));
    }
}